(() => {
  const initializationKey = Symbol.for('nuvora.klarna.initialized');
  if (window[initializationKey] || typeof HTMLDialogElement === 'undefined') return;

  const openSelector = 'button[data-nuvora-klarna-open]';
  const closeSelector = 'button[data-nuvora-klarna-close]';
  let session = null;
  let backdropPointerDialog = null;

  const getDialog = () => {
    const dialog = document.getElementById('NuvoraKlarnaDialog');
    return dialog instanceof HTMLDialogElement ? dialog : null;
  };

  const isOutsideDialog = (event, dialog) => {
    const rect = dialog.getBoundingClientRect();
    return (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    );
  };

  const restoreFocus = (closedSession) => {
    if (getDialog()?.open) return;

    let button = closedSession.opener;
    if (!button.isConnected) {
      const scope = closedSession.sectionId && document.getElementById(closedSession.sectionId);
      if (!scope) return;
      const candidates = Array.from(scope.querySelectorAll(openSelector));
      button = closedSession.productId
        ? candidates.find((candidate) => candidate.dataset.nuvoraKlarnaProductId === closedSession.productId)
        : candidates[closedSession.index];
    }

    if (
      button instanceof HTMLButtonElement &&
      !button.disabled &&
      !button.closest('[inert]') &&
      button.getClientRects().length > 0
    ) {
      button.focus({ preventScroll: true });
    }
  };

  const openDialog = (opener) => {
    const dialog = getDialog();
    if (!dialog || dialog.open || !dialog.isConnected) return;

    const section = opener.closest('[id^="shopify-section-"]');
    session = {
      dialog,
      opener,
      sectionId: section?.id,
      productId: opener.dataset.nuvoraKlarnaProductId,
      index: section ? Array.from(section.querySelectorAll(openSelector)).indexOf(opener) : -1,
    };
    backdropPointerDialog = null;
    dialog.showModal();
  };

  // Keep Escape scoped to this topmost dialog when a cart or search drawer is underneath.
  window.addEventListener(
    'keydown',
    (event) => {
      const dialog = getDialog();
      if (event.key !== 'Escape' || !dialog?.open) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dialog.close();
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      const dialog = getDialog();
      backdropPointerDialog =
        dialog?.open && event.target === dialog && isOutsideDialog(event, dialog) ? dialog : null;
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest(`${openSelector}, ${closeSelector}`);
      if (button instanceof HTMLButtonElement && !button.disabled) {
        event.preventDefault();
        event.stopPropagation();

        if (button.matches(openSelector)) {
          openDialog(button);
        } else {
          const dialog = button.closest('#NuvoraKlarnaDialog');
          if (dialog instanceof HTMLDialogElement && dialog.open) dialog.close();
        }
        backdropPointerDialog = null;
        return;
      }

      const dialog = getDialog();
      if (
        dialog?.open &&
        event.target === dialog &&
        backdropPointerDialog === dialog &&
        isOutsideDialog(event, dialog)
      ) {
        dialog.close();
      }
      backdropPointerDialog = null;
    },
    true
  );

  document.addEventListener(
    'close',
    (event) => {
      if (!session || event.target !== session.dialog || session.dialog.open) return;
      const closedSession = session;
      session = null;
      backdropPointerDialog = null;
      restoreFocus(closedSession);
    },
    true
  );

  window[initializationKey] = true;
})();
